<template>
  <div v-if="data" class="modal__body">
    <section class="card radial">
      <div class="radial card-bordered">
        <radial-chart :value="data.progress.percent?.toFixed(2)" label="Gestion total" percent />

        <span class="progress">{{ strategyProgress }}</span>
      </div>
    </section>

    <section class="card card--stat card--no-border">
      <p class="card__title">
        <span> Grupos </span>
        <span> Cantidad de teléfonos </span>
      </p>

      <IvrStatusChart :data="data" :type="type" />
    </section>

    <section class="card chart">
      <p class="card__title">
        Gráfico de grupos
      </p>
      <div class="align-center">
        <VueApexCharts
          v-if="showDashboard"
          class="chart__graph"
          type="donut"
          height="50%"
          :options="chartConfig.options"
          :series="chartConfig.series"
        />

        <span v-else class="chart__message">No hay suficientes datos para mostrar el gráfico</span>
      </div>
    </section>

    <section class="card">
      <dashboard-call-monitoring-ivr-return :data="data" />
    </section>
  </div>
</template>

<script>
import { inject, computed } from "vue";

import RadialChart from "@/app/strategies/components/charts/RadialChart.vue";
import DashboardCallMonitoringIvrReturn from "@/app/strategies/components/tables/DashboardCallMonitoringIvrReturn.vue";
import { PhoneOutlined, InfoCircleOutlined } from "@ant-design/icons-vue";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

import phoneDialingImage from "@/app/strategies/assets/phone_dialing.svg?url";
import phoneCheckImage from "@/app/strategies/assets/phone_check.svg?url";
import phoneNoneImage from "@/app/strategies/assets/phone_none.svg?url";
import IvrStatusChart from "../../charts/IvrStatusChart.vue";
import VueApexCharts from "vue3-apexcharts";

export default {
  components: {
    RadialChart,
    DashboardCallMonitoringIvrReturn,
    PhoneOutlined,
    CustomScrollbar,
    InfoCircleOutlined,
    IvrStatusChart,
    VueApexCharts,
  },
  props: {
    data: {
      required: false,
      type: Object,
      default: null,
    },
    type: {
      required: true,
      type: Number,
    },
  },
  setup(props) {
    const strategyProgress = inject("strategyProgress");

    const chartConfig = computed(() => {
      const options = {
        chart: { type: "donut", width: "100%" },
        labels: [
          "Contestado",
          "Derivado",
          "No contesta",
          "Ocupada",
          "Fallada",
          "Abandonada"
        ],
        colors: ["#87E8DE", "#D3ADF7", "#FFE58F", "#B7EB8F", "#FFA39E", "#EAFF8F"],
        legend: { show: false },
        tooltip: {
          theme: "light",
          style: { fontSize: "14px" },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`,
          style: {
            colors: ["#000"],
            fontFamily: "Inter, 'Segoe UI', Roboto, Arial, sans-serif",
            fontSize: "14px", // tamaño de letra
            fontWeight: "400",
          },
          dropShadow: {
            enabled: false, // evita sombras blancas
          },
        },
      };

      const series = [
        props.data.calls_statistics?.answered || 0,
        props.data.calls_statistics?.derived || 0,
        props.data.calls_statistics?.no_answered || 0,
        props.data.calls_statistics?.busy || 0,
        props.data.calls_statistics?.failed || 0,
        props.data.calls_statistics?.abandoned || 0,
      ];

      return { options, series };
    });

    const showDashboard = computed(() => !chartConfig.value.series.every((value) => value === 0));

    return { strategyProgress, phoneDialingImage, phoneCheckImage, phoneNoneImage, chartConfig, showDashboard };
  },
};
</script>

<style lang="sass" scoped>
.modal
  &__body
    color: $gray-9
    height: 600px
    display: grid
    grid-template-columns: repeat(6, 1fr)
    grid-template-rows: repeat(3, 1fr)
    gap: 12px

  &__picker
    margin-bottom: 12px

  &__paragraph
    margin: 16px 0

.radial
  display: grid
  place-content: center

  .progress
    text-align: center

.align-center
  height: 100%
  display: flex
  align-items: center
  justify-content: center

.card
  border: $border-normal
  border-radius: 2px
  padding: 5px 10px

  &__title
    font-weight: 600
    margin-bottom: 12px
    display: flex
    justify-content: space-between
    width: 100%

  &__icon
    font-size: 32px
    margin: 4px 0

    & img
      display: block
      margin: 6px 0
      height: 36px

    &--red
      color: $red-6

  &__value
    font-size: 30px
    line-height: 38px
    margin-bottom: -4px

  &__accordion
    padding: 0

  &--stat
    display: flex
    flex-direction: column
    align-items: center
    padding-top: 20px

  &--no-border
    border: none
    padding: 0

  &:nth-child(1)
    grid-column: 1 / 3
    grid-row: 1 / 1

  &:nth-child(2)
    grid-column: 1 / 3
    grid-row: 2 / 7

  // &:nth-child(3)
  //   grid-column: 2 / 2
  //   grid-row: 3 / 5

  // &:nth-child(4)
  //   grid-column: 1
  //   grid-row: 5 / 7

  // &:nth-child(5)
  //   grid-column: 2
  //   grid-row: 5 / 7

  &:nth-child(3)
    grid-column: 3 / 5
    grid-row: 1 / 7

  &:nth-child(4)
    grid-column: 5 / 7
    grid-row: 1 / 4

  &:nth-child(5)
    grid-column: 5 / 7
    grid-row: 4 / 7

  &:nth-child(6)
    grid-column: 7 / 10
    grid-row: 1 / 7
</style>
